import {access} from "@babel/core/lib/config/validation/option-assertions";

export default {
    data() {
        return {
            // 登录窗口样式
            stylePcLogin: {
                'width': '45%',
                'margin-left': '5%',
                'color': '#000000',
                'float': 'right',
                'background-color': 'rgba(255, 255, 255, 1)',
                'margin-right': '3%',
                'margin-top': '2.5%',
                'border-radius': '20px',
                'height': '90%'
            },
            styleAZLogin: {
                'margin-left': '5%',
                'color': '#000000',
                'float': 'right',
                'background-color': 'rgba(255, 255, 255, 1)',
                'margin-right': '3%',
                'margin-top': '2.5%',
                'border-radius': '20px',
                'height': '90%'
            },
            // 端口参数状态
            statusPC: sessionStorage.getItem('statusPC'),
            // 用户登录参数
            userLoginData: {
                access: '',
                password: '',

            },
            // 发送验证码参数-验证邮箱验证码是否正确参数
            emailCodeFlagData: {
                email: '',
                emailCode: ''
            },
            //用户注册参数
            addEmailUserData: {
                email: '',
                password: '',
                passwordYes: '', //确认密码
                emailCode: ''
            },
            // 文本框校验
            rules: {
                email: [
                    {required: true, message: '请输入邮箱账号', trigger: 'blur'},
                ],
                emailCode: [
                    {required: true, message: '请输入验证码', trigger: 'blur'},
                ],
                password: [
                    {required: true, message: '请输入密码', trigger: 'blur'},
                ],
                passwordYes: [
                    {required: true, message: '请再次确认密码', trigger: 'blur'},
                ],
            },
            // 是否同意条款
            checked: false,
            // 登录状态\注册状态
            addUserAndLogin: true,


            // 倒计时组件
            show: true,
            count: '',
            timer: null,

            // 按钮禁用状态
            disabledButton: false
        };
    },
    methods: {
        // 用户登录方法
        async userLogin() {
            if (!this.checked) {
                this.$message.error('请阅读并同意用户协议和隐私协议');
                return
            }

            const res = await this.$api.post(this.$apiUrl.userLogin, this.userLoginData)
            if (res.code == 20000) {
                this.$message.success('登录成功, 欢迎您：' + res.data.vo.userAccess);
                // 将用户信息存入 localStorage
                localStorage.setItem('userTK', res.data.vo.tk);
                localStorage.setItem('userName', res.data.vo.userAccess)
                localStorage.setItem('userId', res.data.vo.userId)
                this.$router.push('/')
            }
        },
        // 获取验证码
        async getEmailAndSJCode() {
            this.emailCodeFlagData.email = this.addEmailUserData.email
            // 验证邮箱是否为空
            if (this.emailCodeFlagData.email === '') {
                this.$message.error('当前未输入手机号或邮箱')
                return
            }

            // 邮箱正则
            var emailPatternaa = /^(\w*\.*)+@(\w-?)+(\.\w{2,3}){1,2}$/
            // 手机号正则
            var accessPattern =  /^1[3456789]\d{9}$/;
            // 验证邮箱或手机号是否存在问题
            if (!emailPatternaa.test(this.emailCodeFlagData.email) && !accessPattern.test(this.emailCodeFlagData.email)) {
                this.$message.error("您输入邮箱或手机号有误")
                return
            }

            // 验证发送邮箱验证码或者发送手机验证码
            if (emailPatternaa.test(this.emailCodeFlagData.email)) {
                // 发送邮箱验证码
                const res = await this.$api.post(this.$apiUrl.emailCode, this.emailCodeFlagData)
                if (res.code == 20000) {
                    this.$message.success('验证码已发送')
                } else {
                    this.$message.error('验证码发送失败')
                    return
                }
            } else if (accessPattern.test(this.emailCodeFlagData.email)) {
                // 手机验证码赋值
                var sendData = {
                    phone: this.emailCodeFlagData.email
                }
                // 发送手机验证码
                const res = await this.$api.post(this.$apiUrl.send, sendData)
                if (res.code == 20000) {
                    this.$message.success('验证码已发送')
                } else {
                    this.$message.error('发送失败')
                    return
                }
            }
            // 倒计时
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count -= 1;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        },
        //用户注册方法
        async userRegister() {
            // 邮箱正则
            var emailPatternaa = /^(\w*\.*)+@(\w-?)+(\.\w{2,3}){1,2}$/
            // 手机号正则
            var accessPattern =  /^1[3456789]\d{9}$/;

            // 验证邮箱验证码或者手机验证码
            if (emailPatternaa.test(this.emailCodeFlagData.email)) {
                // 验证码赋值
                this.emailCodeFlagData.email = this.addEmailUserData.email
                this.emailCodeFlagData.emailCode = this.addEmailUserData.emailCode
                // 验证码是否正确
                const res = await this.$api.post(this.$apiUrl.emailCodeYN, this.emailCodeFlagData)
                if (res.code != 20000) {
                    this.$message.error('验证码有误')
                    return
                }
                if (this.addEmailUserData.password != this.addEmailUserData.passwordYes) {
                    this.$message.error("两次密码输入不一致，请重新输入")
                    return
                }
                const addUserRes = await this.$api.post(this.$apiUrl.addEmailUser, this.addEmailUserData)
                if (addUserRes.code == 20000) {
                    this.$message.success("注册成功")
                    this.addUserAndLogin = true
                } else {
                    this.$message.error(addUserRes.success)
                }
            } else if (accessPattern.test(this.emailCodeFlagData.email)) {
                // 验证码赋值
                var sendCodeYNData = {
                    account: this.addEmailUserData.email,
                    sentCode: this.addEmailUserData.emailCode
                }
                // 验证码是否正确
                const res = await this.$api.post(this.$apiUrl.sendCodeYN, sendCodeYNData)
                if (res.code != 20000) {
                    this.$message.error('验证码有误')
                    return
                }
                if (this.addEmailUserData.password != this.addEmailUserData.passwordYes) {
                    this.$message.error("两次密码输入不一致，请重新输入")
                    return
                }
                const addUserRes = await this.$api.post(this.$apiUrl.addEmailUser, this.addEmailUserData)
                if (addUserRes.code == 20000) {
                    this.$message.success("注册成功")
                    this.addUserAndLogin = true
                } else {
                    this.$message.error(addUserRes.message)
                }
            }
        },
        // 查看用户协议
        goToUserAgreement() {
            this.$router.push('/userAgreement')
        },
        // 查看用户协议
        goToPrivacyPolicy() {
            this.$router.push('/privacyPolicy')
        }
    }
}